import { ORPCError } from "@orpc/client";
import { isAbortOrCancelledError } from "@shared/lib/react-query/cancelled-error";
import {
	defaultShouldDehydrateQuery,
	QueryCache,
	QueryClient,
} from "@tanstack/react-query";

export function createQueryClient() {
	return new QueryClient({
		queryCache: new QueryCache({
			onError: (error) => {
				// Cancel / abort is normal during transitions and invalidate+refetch.
				if (isAbortOrCancelledError(error)) {
					return;
				}
				// oRPC link interceptor already logs procedure-level errors.
				if (error instanceof ORPCError) {
					return;
				}
				console.error("Query error:", error);
			},
		}),
		defaultOptions: {
			queries: {
				staleTime: 60 * 1000,
				retry: (failureCount, error) => {
					if (!(error instanceof ORPCError)) {
						return false;
					}
					if (failureCount >= 2) {
						return false;
					}
					return (
						error.code === "SERVICE_UNAVAILABLE" ||
						error.code === "BAD_GATEWAY" ||
						error.code === "GATEWAY_TIMEOUT" ||
						(error.code === "INTERNAL_SERVER_ERROR" &&
							error.message
								.toLowerCase()
								.includes("database temporarily unavailable"))
					);
				},
				retryDelay: (attempt) => Math.min(250 * 2 ** attempt, 2_000),
			},
			dehydrate: {
				shouldDehydrateQuery: (query) =>
					defaultShouldDehydrateQuery(query) ||
					query.state.status === "pending",
			},
		},
	});
}
